import { usePaintCalendarBuilder } from './hooks';
import { IJxtPaintCalendar } from './types';
import './styles.scss';
import { useRef } from 'react';
import useIsOverflow from '../../hooks/useIsOverflow';
import { clsx } from 'clsx';
import { getGridStyles } from './getGridStyles';

const JxtPaintCalendar = ({ date, events = [], hasSaturdayWeek = false }: IJxtPaintCalendar) => {
  const { headers, dates, periodSelectors } = usePaintCalendarBuilder(events, date, hasSaturdayWeek);
  const ref = useRef<HTMLDivElement | null>(null);
  const isOverflowing = useIsOverflow(ref);
  const styles = getGridStyles(hasSaturdayWeek);
  const baseClasses = 'grid calendar-grid month gap-2 text-center';

  return (
    <div ref={ref} className={clsx(baseClasses, isOverflowing ? '-mr-3' : '')} style={styles as React.CSSProperties}>
      {headers}
      {periodSelectors}
      {dates}
    </div>
  );
};

export default JxtPaintCalendar;
